const defaultChoiceHover = {
    xPos: null,
    yPos: null
};

const choiceHover = ( state=defaultChoiceHover, action ) => {
    switch( action.type ){
        case "SET_HOVER_POS":
            return {
                xPos: action.xPos,
                yPos: action.yPos
            };
        default:
            return defaultChoiceHover;
    }
};

export default choiceHover;


// WEBPACK FOOTER //
// ./src/reducers/choice-hover.js